import { Tag } from "primereact/tag";
import { getColorByEnv } from "../../utils/GetColorByEnv";

export const TagEnv = ({
  name,
  code,
}: {
  name: string | undefined;
  code: string | undefined;
}) => {
  const iconColor = getColorByEnv(code);

  const icon = () => {
    return (
      <>
        <i className="pi pi-circle-fill mr-2" style={{ color: iconColor, fontSize: "inherit"  }}></i>
      </>
    );
  };

  return (
    <>
      <Tag
        value={name}
        icon={icon}
        style={{fontSize: "0.7rem", backgroundColor:"#f5f5f5", color:"#64748b" }}
      ></Tag>
    </>
  );
};
